<template>
    <div>
        <v-card class="fill-height" elevation="0">
            <Announcement type="t4a" />
            <v-card color="#A5D6A7" elevation="0" height="120px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-file-export</v-icon>
                    &nbsp;T4A Form
                </v-card-title>
            </v-card>
            <v-card-text>
                <Documents type="T4A" />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Announcement from "../../../components/Student/Announcements/Announcement.vue"
import Documents from "../../../components/Student/Documents/RetrieveDocuments.vue"
export default {
    components: {
        Announcement,
        Documents
    }
}
</script>